<template>
  <div :class="rootClass">
    <b-row>
      <b-col cols="12">
        <b-row class="mb-2">
          <b-col lg="3" sm="12">
            <b-row align-v="center">
              <label :class="rootClass + '__search-label'">Số thuê bao</label>
              <b-form-input
                  ref="inputSearchKey"
                  v-model="searchKey"
                  :class="rootClass + '__search-input'"
                  placeholder="9 số hoặc 14 số"
                  v-on:keyup.enter="getRechargeHistory"
              ></b-form-input>
            </b-row>
          </b-col>
          <b-col lg="3" sm="12" style="margin-left: -2%;">
            <b-row align-v="center">
              <label :class="rootClass + '__from-date-label'">Từ ngày</label>
              <b-form-datepicker
                  v-model="fromDate"
                  :class="rootClass + '__from-date-input'"
                  :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                  }"
                  locale="vi-VN"
                  style="font-size: 16px;font-weight: 500 !important;color: black !important;"
              />
            </b-row>
          </b-col>
          <b-col lg="3" sm="12" style="margin-left: -3%;">
            <b-row align-v="center">
              <label :class="rootClass + '__to-date-label'">Đến ngày</label>
              <b-form-datepicker
                  v-model="toDate"
                  :class="rootClass + '__to-date-input'"
                  :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                  }"
                  locale="vi-VN"
                  style="font-size: 16px;"
              />
            </b-row>
          </b-col>
          <b-col lg="2" sm="12" style="display: flex; align-items: center">
            <b-button
                :class="rootClass + '__search-btn'"
                class="redButton"
                variant="danger"
                @click="getRechargeHistory"
            >Tra cứu
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <table :class="rootClass + '__history-table'">
            <tr style="height: 3rem;position: sticky">
              <template v-for="(h, i) in tableFields">
                <th
                    :key="h.key"
                    :class="{
                      '--first-th': i === 0,
                      '--last-th': i === tableFields.length - 1,
                    }"
                    style="min-width: 120px"
                >
                  {{ h.label }}
                </th>
              </template>
            </tr>
            <template v-for="(r,index) in rechargeData" v-if="showErrSearch===false">
              <tr :key="index" style="color:black;">
                <td>{{ r.SoThueBao }}</td>
                <td>{{ r.NgayThangNap }}</td>
                <td>{{ r.GiaTriNap }}</td>
                <td>{{ r.Serial }}</td>
              </tr>
            </template>
          </table>
        </b-row>
        <b-row v-if="showErrSearch" style="justify-content: center;font-size: 18px">
          Không tìm thấy kết quả!
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BFormInput,
  BRow,
  BFormDatepicker,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment/moment";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormDatepicker,
  },
  data() {
    return {
      rootClass: "recharge-history",
      searchKey: "",
      fromDate: new Date(),
      toDate: new Date(),
      showErrSearch: false,
      rechargeData: [],
      tableFields: [
        {key: "soThueBao", label: "Số thuê bao"},
        {key: "ngayThangNap", label: "Ngày tháng nạp"},
        {key: "giaTriNap", label: "Giá trị nạp"},
        {key: "serial", label: "Serial"},
      ]
    };
  },
  props: {
    searchPhone: String
  },
  mounted() {
    if (this.searchPhone) {
      this.searchKey = this.searchPhone;
      this.getRechargeHistory();
    }
  },
  methods: {
    getRechargeHistory() {
      this.showLoading("block")

      if (!this.searchKey) {
        this.showLoading("none")
        this.$toast.error("Vui lòng nhập số thuê bao hoặc serial", {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
        return;
      }

      // Check max 6 months history
      if (moment().diff(moment(this.fromDate), 'months') > 6) {
        this.showLoading("none")
        this.$toast.error("Chỉ được tra cứu trong vòng 6 tháng!", {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
        return;
      }

      const from = moment(this.fromDate).format("YYYY-MM-DD");
      const to = moment(this.toDate).format("YYYY-MM-DD");

      // Kiểm tra ngày bắt đầu phải trước ngày kết thúc
      const checkDate = this.checkDate(from, to);
      if (checkDate > 0) {
        this.showLoading("none")
        this.$toast.error("Ngày bắt đầu phải trước ngày kết thúc", {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
        return;
      }

      // Kiểm tra khoảng thời gian không quá 30 ngày
      if (checkDate < -30) {
        this.showLoading("none")
        this.$toast.error("Thời gian tìm kiếm trong khoảng 30 ngày", {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
        return;
      }

      let searchKeyFormatted = this.searchKey;
      // Xử lý số thuê bao (9 số)
      if (this.searchKey.length === 10 && this.searchKey.startsWith("0")) {
        searchKeyFormatted = this.searchKey.substring(1);
        searchKeyFormatted = 84 + searchKeyFormatted;
      } else if (this.searchKey.length === 9) {
        searchKeyFormatted = 84 + this.searchKey;
      }

      let url = 'get-recharge-info?from=' + from + '&to=' + to;

      // Kiểm tra xem là msisdn hay serial
      if (searchKeyFormatted.length === 11 && searchKeyFormatted.startsWith("84")) {
        url += '&msisdn=' + searchKeyFormatted;
      } else {
        url += '&serial=' + this.searchKey;
      }

      useJwt.get(url).then((response) => {
        this.showLoading("none")
        if (response.data.code === 200) {
          this.rechargeData = response.data.result;
          this.showErrSearch = this.rechargeData.length === 0;
        } else {
          this.showErrSearch = true;
          this.$toast.error(response.data.message, {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        }
        console.log("getRechargeHistory", response.data);
      }).catch((error) => {
        this.showLoading("none")
        this.showErrSearch = true;
        console.log(error);
      });
    },
    checkDate(fromDate, toDate) {
      const from = moment(fromDate);
      const to = moment(toDate);
      return from.diff(to, 'days');
    },
    showLoading(options) {
      document.getElementById('loading-bg').style.display = options;
    },
  }
};
</script>

<style lang="scss" scoped>
.recharge-history {
  position: relative;
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__search-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 120px;
  }

  &__search-input {
    font-weight: 500;
    color: black;
    font-size: 14px;
    width: 200px;
  }

  &__from-date-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__from-date-input {
    width: 200px;
  }

  &__to-date-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__to-date-input {
    width: 200px;
  }

  &__search-btn {
    border-radius: 40px;
  }

  &__history-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    th {
      background-color: #ED1F24;
      color: white;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }
}

.redButton {
  background-color: #ED1F24 !important;
  border-color: #ED1F24 !important;
}

@media screen and (max-width: 576px) {
  .recharge-history {
    &__search-label {
      width: 100%;
    }

    &__search-input {
      width: 100%;
    }

    &__from-date-label {
      width: 100%;
    }

    &__from-date-input {
      width: 100%;
    }

    &__to-date-label {
      width: 100%;
    }

    &__to-date-input {
      width: 100%;
    }
  }
}
</style>
